import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap'
import {
  fetchClients,
  fetchAllRoles,
  fetchClientPortals,
  fetchPortals,
  fetchLocations,
  verifyUserByEmailAndClientId,
  fetchOrganizationRoles
} from '../../actions'
import Spinner from '../spinner'
import AdminForm from './AdminForm'

const AdminNew = props => {
  const [loading, setLoading] = useState(false)
  const [initialLoading, setInitialLoading] = useState(true)

  const loggedInAs = props.currentAdmin.logged_in_as

  useEffect(() => {
    if (loggedInAs === 'Agency') {
      props.fetchClients().then(() => {
        setInitialLoading(false)
      })
      props.fetchAllRoles().then(() => {
        setInitialLoading(false)
      })
      props.fetchClients()
      props.fetchLocations()
    } else if (loggedInAs === 'Organization') {
      props.fetchOrganizationRoles().then(() => {
        setInitialLoading(false)
      })
    }
  }, [])

  if (initialLoading) {
    return <Spinner />
  }

  return (
    <div className="animated fadeIn">
      <Row>
        <Col>
          <Card className="card-accent-primary">
            <CardHeader>
              <strong>New{loggedInAs === 'Organization' ? ' Marketfuel ' : ' '}Admin </strong>
            </CardHeader>
            <CardBody>
              <AdminForm setLoading={setLoading} />
            </CardBody>
          </Card>
        </Col>
        {loading ? <Spinner /> : null}
      </Row>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    errors: Object.values(state.errors),
    currentAdmin: state.admins.current_admin
  }
}

AdminNew.propTypes = {
  fetchClients: PropTypes.func,
  fetchAllRoles: PropTypes.func,
  fetchClientPortals: PropTypes.func,
  fetchPortals: PropTypes.func,
  fetchLocations: PropTypes.func,
  verifyUserByEmailAndClientId: PropTypes.func,
  currentAdmin: PropTypes.object
}

export default connect(mapStateToProps, {
  fetchClients,
  fetchAllRoles,
  fetchClientPortals,
  fetchPortals,
  fetchLocations,
  verifyUserByEmailAndClientId,
  fetchOrganizationRoles
})(AdminNew)

// export for testing
export { AdminNew }
